import { getAuthHeaders } from '../../statistics/api/auth-headers';

/**
 * Публикации по шорткодам со всеми цифрами слайда: сервер сам находит пост
 * среди наших аккаунтов и одним заходом берёт метрики Graph API и ряд
 * просмотров из наших снимков. Сервер — /api/presentation/media (Fastify),
 * нужен вход на сайт.
 */

export type PresentationMedia = {
  shortcode: string;
  mediaId: string;
  username: string;
  /** IMAGE | VIDEO | CAROUSEL_ALBUM. */
  mediaType: string;
  productType: 'FEED' | 'REELS';
  publishedAt: string | null;
  mediaUrl: string | null;
  thumbnailUrl: string | null;
  /** Подпись поста как есть, со всеми переносами. */
  caption: string | null;
  views: number | null;
  reach: number | null;
  likes: number | null;
  comments: number | null;
  shares: number | null;
  saved: number | null;
  totalInteractions: number | null;
  /** Расчётом: взаимодействия − лайки − комментарии − отправки − сохранения. */
  reposts: number | null;
  profileVisits: number | null;
  follows: number | null;
  avgWatchMs: number | null;
  totalWatchMs: number | null;
  skipRate: number | null;
  viewsSeries: Array<{ date: string; views: number }>;
  /** Почему метрик нет или пришли не все. */
  metricsError?: string;
};

export type PresentationMediaResponse = {
  media: PresentationMedia[];
  errors: Array<{ shortcode: string; error: string }>;
};

/** Столько шорткодов сервер принимает за раз. */
export const MEDIA_BATCH_SIZE = 50;

export async function fetchPresentationMedia(shortcodes: string[]): Promise<PresentationMediaResponse> {
  const res = await fetch('/api/presentation/media', {
    method: 'POST',
    headers: await getAuthHeaders(),
    body: JSON.stringify({ shortcodes }),
  });
  if (!res.ok) {
    const body = (await res.json().catch(() => ({}))) as { error?: string };
    throw new Error(body.error || `Ошибка сервера статистики: ${res.status}`);
  }
  return (await res.json()) as PresentationMediaResponse;
}
